module.exports = __webpack_public_path__ + "img/ico-contact-company_2.cde2fcec.svg";